var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"}));
}

Calendar.defaultProps = {"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true","className":"w-5 h-5 text-gray-700 group-focus-within:text-violet-700"};

module.exports = Calendar;

Calendar.default = Calendar;
